import { FEATURES, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export default [
  {
    path: '/data-room',
    name: 'dataRoom',
    redirect: '/data-room/geral',
    meta: {
      can_show: FEATURES.PARTNERSHIP_DATA_ROOM,
      permission: ['gestor', 'financeiro'],
      search: {
        title: 'Data room',
        description: 'Documentos e arquivos do data room',
        keywords: ['data room', 'documentos', 'arquivos', 'partnership'],
        icon: 'mdi-database',
        group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
      },
    },
    component: () =>
      lazyLoadView(
        import('@src/modules/data-room/views/nav-bar/view-nav-bar.vue')
      ),
    children: [
      {
        path: 'geral',
        name: 'dataRoom.overview',
        meta: {
          can_show: FEATURES.PARTNERSHIP_DATA_ROOM,
          permission: ['gestor', 'financeiro'],
          search: {
            title: 'Data room — Visão Geral',
            description: 'Visão geral do data room',
            keywords: ['data room', 'visão geral', 'documentos', 'arquivos'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(import('@modules/partnership/views/view-data-room.vue')),
      },
    ],
  },
]
